import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles({
});

function Trash(props) {
    const classes = useStyles();

    return (
        <h1>Trash settings</h1>
    );
}

export default Trash